// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___txIKP","title":"style-module__title___sdcIW","info":"style-module__info___guh_3"};
    if(module.hot) {
      // 1729151133259
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  